var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11L0.414348 10.5315L0.0395314 11L0.414348 11.4685L1 11ZM10 11.75C10.4142 11.75 10.75 11.4142 10.75 11C10.75 10.5858 10.4142 10.25 10 10.25V11.75ZM4.41435 5.53148L0.414348 10.5315L1.58565 11.4685L5.58565 6.46852L4.41435 5.53148ZM0.414348 11.4685L4.41435 16.4685L5.58565 15.5315L1.58565 10.5315L0.414348 11.4685ZM1 11.75H10V10.25H1V11.75Z",
    fill: "#EB5545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.13193V6.38851C9 4.77017 9 3.961 9.47396 3.4015C9.94792 2.84201 10.7461 2.70899 12.3424 2.44293L14.0136 2.1644C17.2567 1.62388 18.8782 1.35363 19.9391 2.25232C21 3.15102 21 4.79493 21 8.08276V13.9172C21 17.2051 21 18.849 19.9391 19.7477C18.8782 20.6464 17.2567 20.3761 14.0136 19.8356L12.3424 19.5571C10.7461 19.291 9.94792 19.158 9.47396 18.5985C9 18.039 9 17.2298 9 15.6115V15.066",
    stroke: "#EB5545",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutGroup);
export default __webpack_public_path__ + "static/media/out_group.8eb16babdc6e276b92966dcde65caf46.svg";
export { ForwardRef as ReactComponent };